import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { typography } from '../../../styled';
const {
  sans: {
    copy: { Nano }
  }
} = typography;

interface InputContainerProps {
  gridArea?: string;
  type?: string;
}

const InputContainer = styled.div`
  border-bottom: solid 1px black;
  display: flex;
  flex-direction: column;
  grid-area: ${({ gridArea }: InputContainerProps) => gridArea};
  /* Don't want all the jumping around when these load */
  height: ${({ type }: InputContainerProps) => (type === 'cc' ? '55px' : 'auto')};
`;

const Label = styled(Nano)`
  margin: 0;
  margin-bottom: 5px;
`;

type Props = {
  children: ReactNode;
  label?: string;
  gridArea?: string;
  type?: 'cc' | 'text';
};

const Input = (props: Props) => {
  const { children, label, gridArea, type = 'text' } = props;

  return (
    <InputContainer gridArea={gridArea} type={type}>
      {label && <Label>{label.toUpperCase()}</Label>}
      {children}
    </InputContainer>
  );
};

export default Input;
